export const formatCustomer = (value: unknown) => {
  if (value === null || value === undefined) {
    return ''; // Возвращаем пустую строку, если входные данные невалидны
  }

  const stringValue = String(value);

  // Удаляем все нецифровые символы
  const cleaned = stringValue.replace(/\D/g, '');

  // Проверяем, что строка не пустая и имеет 10 цифр (для формата XXX-XXX-XXXX)
  if (cleaned.length !== 10) {
    return stringValue; // Возвращаем исходную строку, если формат не подходит
  }

  // Форматируем номер: 5986864749 → 598-686-4749
  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}
